module.exports = __webpack_public_path__ + "assets/fc061574dfc5e23d8a59f566674fb81a.png";